import styled, { css } from "styled-components";

const StyledChip = styled.span`
  font-family: Open Sans;
  background: #d1e9cb;
  border-radius: 16px;
  text-align: center;
  margin-left: 15px;
  font-family: Open Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #222222;
  padding: 0.2rem 0.4rem;
  font-size: 0.875rem;
  white-space: nowrap;
  ${(props) =>
    props.difficulty === "Easy" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.easy};
    `};
  ${(props) =>
    props.difficulty === "Easiest" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.easiest};
    `};
  ${(props) =>
    props.difficulty === "Moderate" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.moreDifficult};
    `};
  ${(props) =>
    props.difficulty === "Difficult" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.veryDifficult};
    `};
  ${(props) =>
    props.difficulty === "Extreme" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.extremelyDifficult};
      color: #ffffff;
    `};
  ${(props) =>
    props.difficulty === "Not Assessed" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.notAssessed};
      border: 1px solid #222222;
    `};
  ${(props) =>
    props.type === "Closed" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.status};
      color: ${({ theme }) => theme.palette.semantic.closed};
      top: 13px;
      right: 13px;
      position: absolute;
    `};
  ${(props) =>
    props.type === "PartClosed" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.status};
      color: ${({ theme }) => theme.palette.semantic.partClosed};
      top: 13px;
      right: 13px;
      position: absolute;
    `};
  ${(props) =>
    props.type === "FeaturedRoute" &&
    css`
      background: ${({ theme }) => theme.palette.semantic.status};
      color: ${({ theme }) => theme.palette.primary.main};
      top: 13px;
      right: 13px;
      position: absolute;
    `};
`;

export { StyledChip };
